<script setup lang="ts">
    import { useForm, usePage } from '@inertiajs/vue3';
    import { OnboardingStep, SharedData } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import OnboardingStepForm from './OnboardingStepForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { computed } from 'vue';
    import { Table } from '@tanstack/vue-table';

    const props = defineProps<{
        onboardingStep: OnboardingStep;
        table: Table<OnboardingStep>;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        service: props.onboardingStep.service,
        other_title: props.onboardingStep.other_title,
        description: props.onboardingStep.description_translated,
        allow_comments: props.onboardingStep.allow_comments,
        allow_files: props.onboardingStep.allow_files,
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.onboarding.update', { companyOnboardingStep: onboardingStep.id })"
        method="patch"
        :query-key="[QueryKey.ONBOARDING, selectedCompanyId]"
        title="onboarding.edit_step"
    >
        <OnboardingStepForm
            :form="form"
            :table="table"
            :disable-service-change="true"
        />
    </DialogForm>
</template>
